import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-empty-team',
    templateUrl: './empty-team.component.html',
    styleUrls: ['./empty-team.component.scss'],
    standalone: false
})
export class EmptyTeamComponent {
    @Output() invitationSent = new EventEmitter<string>();

    constructor() {
    }

}
